import BlockContent from "./BlockContent"
export * from "./BlockContent"
export default BlockContent
